module.exports = __webpack_public_path__ + "media/images/success/phone-fab23a27ead64a5f20149f778d2c9ec4.png";